function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/InformationApi";
import * as Utility from "../commons/Utility";
import * as InformationModalComponent from "./InformationModalComponent";
import { NullNumberToBlank } from "../commons/Utility";
import IntlMessage from '../commons/Intl';
import { Placeholder, Informations, Action } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Selected: null,
      OrganizationId: 0,
      InformationList: [],
      InformationModalMode: InformationModalComponent.Mode.None,
      SearchText: "",
      CurrentPage: 1,
      DataCount: 0,
      DataAllCount: 0
    };

    _this.GetList(_this.state.CurrentPage);

    return _this;
  }
  /**
   * 対象の検索テキストを更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateSearchText",
    value: function updateSearchText(e) {
      this.setState({
        SearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * リスト表示
     */

  }, {
    key: "GetList",
    value: function GetList(pageNum) {
      var _this2 = this;

      Api.QueryView(this.state.SearchText, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this2.setState({
          Selected: null,
          OrganizationId: data.OrganizationId,
          InformationList: data.InformationList,
          DataCount: data.Count,
          DataAllCount: data.AllCount
        });
      });
    }
    /**
     * 前ページ表示
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;

      if (this.state.CurrentPage <= 1) {
        page = 1;
      } else {
        page = this.state.CurrentPage - 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 次ページ表示
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;
      var maxPage = Math.ceil(this.state.DataCount / this.props.pageSize);

      if (maxPage == 0) {
        page = 1;
      } else if (this.state.CurrentPage >= maxPage) {
        page = maxPage;
      } else {
        page = this.state.CurrentPage + 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * お知らせモーダルを読み取り専用で起動します。
     */

  }, {
    key: "openReadOnlyInformationModal",
    value: function openReadOnlyInformationModal(m) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        InformationModalMode: InformationModalComponent.Mode.ReadOnly,
        Selected: {
          InformationId: m.InformationId,
          Title: m.Title,
          Contents: m.Contents,
          StartDateTime: m.StartDateTime,
          EndDateTime: m.EndDateTime,
          OrganizationId: m.OrganizationId,
          Notified: m.Notified,
          Readed: m.Readed,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * お知らせを検索します。
     *
     * @param searchText 検索文字列
     */

  }, {
    key: "searchInformation",
    value: function searchInformation() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 1;
      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * お知らせを登録します。
     *
     */

  }, {
    key: "entryInformationModal",
    value: function entryInformationModal() {}
    /**
     * お知らせを更新します。
     *
     */

  }, {
    key: "modifyInformationModal",
    value: function modifyInformationModal() {}
    /**
     * お知らせを削除します。
     *
     */

  }, {
    key: "deleteInformationModal",
    value: function deleteInformationModal() {}
    /**
     * お知らせを既読にします。
     *
     * @param id お知らせID
     * @param updateDateTime 更新日時
     */

  }, {
    key: "closeInformationModal",
    value: function closeInformationModal(id, updateDateTime) {
      var _this3 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.ReadedInformation(id, updateDateTime, function () {
        _this3.setState({
          Selected: null
        });

        var badge = $('#badge');

        if (badge) {
          var count = Number(badge.text());
          count = count - 1;
          badge.text(count.toString());

          if (count == 0) {
            badge.hide();
          }
        }

        _this3.GetList(_this3.state.CurrentPage);

        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
      });
    }
    /**
     * お知らせモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenInformationModal",
    value: function hiddenInformationModal() {
      this.setState({
        InformationModalMode: InformationModalComponent.Mode.None
      });
      this.GetList(this.state.CurrentPage);
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      var _this4 = this;

      this.props.common.submit(function () {
        _this4.props.common.createAction("Back");
      }, false, true);
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        width: "60",
        height: "60",
        src: "/assets/img/Icon_Notification_Gray.svg"
      }), /*#__PURE__*/React.createElement("h2", null, intl.format(Informations.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control-search",
        name: "search",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this5.updateSearchText(e);
        },
        value: this.state.SearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-6 search-btn"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.searchInformation.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Search"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.InformationList.length == 0 && /*#__PURE__*/React.createElement("li", {
        className: "list-group-item",
        key: 0
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }, "-"), /*#__PURE__*/React.createElement("div", {
        className: "col-11",
        style: {
          wordWrap: "break-word"
        }
      }, intl.format(Informations.NoNotification)))), this.state.InformationList.length > 0 && this.state.InformationList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.InformationId
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-1"
        }, (_this5.state.CurrentPage - 1) * _this5.props.pageSize + _i + 1), /*#__PURE__*/React.createElement("div", {
          className: "col-9 cursorpointer",
          style: {
            wordWrap: "break-word"
          },
          onClick: _this5.openReadOnlyInformationModal.bind(_this5, x)
        }, x.Title, x.Readed ? "" : /*#__PURE__*/React.createElement("img", {
          width: "50",
          height: "30",
          style: {
            marginLeft: "10px"
          },
          src: "/assets/img/new_icon.svg"
        })), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this5.openReadOnlyInformationModal.bind(_this5, x)
        }, Utility.ToMoment(x.StartDateTime).format("YYYY-MM-DD"))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1 offset-10 text-right"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        key: "onBack",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onBack.bind(this),
        tabIndex: 107
      }, intl.format(Action.Back))), this.state.InformationModalMode != InformationModalComponent.Mode.None && /*#__PURE__*/React.createElement(InformationModalComponent["default"], {
        mode: this.state.InformationModalMode,
        currentOrganizationId: this.state.OrganizationId,
        informationId: NullNumberToBlank(this.state.Selected ? this.state.Selected.InformationId : null),
        title: this.state.Selected ? this.state.Selected.Title : "",
        contents: this.state.Selected ? this.state.Selected.Contents : "",
        startDateTime: this.state.Selected ? this.state.Selected.StartDateTime : null,
        endDateTime: this.state.Selected ? this.state.Selected.EndDateTime : null,
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        organizationId: this.state.Selected ? this.state.Selected.OrganizationId : null,
        readed: this.state.Selected ? this.state.Selected.Readed : 0,
        onEntry: this.entryInformationModal.bind(this),
        onModify: this.modifyInformationModal.bind(this),
        onDelete: this.deleteInformationModal.bind(this),
        onClose: this.closeInformationModal.bind(this),
        onHidden: this.hiddenInformationModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param pageSize ページサイズ
 */


export default function (el, common, pageSize) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    pageSize: pageSize
  }), el);
}